import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = {
  class: "modal-content",
  style: {"height":"calc(100vh - 50px)"}
}
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "input-group input-group-lg" }
const _hoisted_11 = { class: "list-group" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "fa-regular fa-square-check"
}
const _hoisted_14 = {
  key: 1,
  class: "fa-regular fa-square"
}

import { ref, computed } from 'vue'

    import type { SurveyCriteriaManagerDialogViewModel } from '@Evaluation/AlternativesSurveys/Components/SurveyCriteriaManagerDialog'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyCriteriaManagerDialog',
  props: {
    viewModel: {}
  },
  emits: ["update-survey-criteria"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- shortcuts ---------------- */

    const vm = computed(() => props.viewModel)
    const opened = computed(() => vm.value?.opened ?? false)

    /* ---------------- derived ---------------- */

    const initialized = computed(() => vm.value.rm != null)
    const criteria = computed(() => vm.value.rm?.Criteria ?? [])
    const surveyId = computed(() => vm.value.surveyId)
    const surveyName = computed(() => vm.value.surveyName)

    /* ---------------- local state ---------------- */

    const searchPhrase = ref<string | null>(null)

    /* ---------------- computed ---------------- */

    const criteriaView = computed(() =>
    {
        if (searchPhrase.value)
        {
            const phrase = searchPhrase.value.toLowerCase()
            return criteria.value.filter(c =>
                (c.Path + c.Name).toLowerCase().includes(phrase)
            )
        }

        return criteria.value
    })

    /* ---------------- actions ---------------- */

    function emitUpdateCriteria()
    {
        const selectedCriteriaIds = criteria.value
            .filter(c => c.IsIncluded === true)
            .map(c => c.Id)

        emit('update-survey-criteria', surveyId.value, selectedCriteriaIds)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, "Select criteria: " + _toDisplayString(surveyName.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (initialized.value === false)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _cache[3] || (_cache[3] = _createElementVNode("div", {
                        class: "alert alert-info alert-dismissible",
                        role: "alert"
                      }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "close",
                          "data-dismiss": "alert",
                          "aria-label": "Close"
                        }, [
                          _createElementVNode("span", { "aria-hidden": "true" }, "×")
                        ]),
                        _createTextVNode(" You can limit which criteria are included in your panel. To do that, simply check the criteria you want to include from the list below. "),
                        _createElementVNode("strong", null, "WARNING: New criteria won't be included in panels automatically.")
                      ], -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "search",
                          placeholder: "Search for a criterion...",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, searchPhrase.value]
                        ]),
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "input-group-append" }, [
                          _createElementVNode("span", { class: "input-group-text" }, [
                            _createElementVNode("i", {
                              class: "fa-solid fa-magnifying-glass",
                              "aria-hidden": "true"
                            })
                          ])
                        ], -1 /* CACHED */))
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteriaView.value, (c) => {
                          return (_openBlock(), _createElementBlock("button", {
                            type: "button",
                            key: c.Id,
                            onClick: ($event: any) => (c.IsIncluded = !c.IsIncluded),
                            class: "list-group-item list-group-item-action"
                          }, [
                            (c.IsIncluded === true)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                              : _createCommentVNode("v-if", true),
                            (c.IsIncluded === false)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                              : _createCommentVNode("v-if", true),
                            _createTextVNode(" " + _toDisplayString(c.Path), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_12))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: emitUpdateCriteria,
                  type: "button",
                  class: "btn btn-primary"
                }, "Save & Close"),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})